import { Navigate, useLocation, useOutletContext } from "react-router";
import { SurveyExternalContext } from "./context";

export default function SurveyExternalPage() {
  const location = useLocation();
  const { token, surveyDeliveryId } = useOutletContext<SurveyExternalContext>();

  if (token && surveyDeliveryId) {
    return <Navigate to={{ pathname: "submit", search: location.search }} replace />;
  }

  return null;
}
